<template>
  <v-app>
    <core-app-bar />
    <core-app-drawer />
    <core-view />
  </v-app>
</template>
<script>
export default {
  components: {
    CoreAppBar: () => import('@/components/core/AppBar'),
    CoreAppDrawer: () => import('@/components/core/AppDrawer'),
    CoreView: () => import('@/components/core/AppView')
  }
}
</script>
